import instance from "../utils/instance";

class customerService {
    async getImportConfirmData(batchId) {
        return await instance.get('/crm/importCustomer/getErrorMessage?batch=' + batchId);
    }

    async submitImportConfirmData(data,batchId,categoryId) {
    	return await instance.post('/crm/importCustomer/updataAndSaveCsv',{
    		batch:batchId,
            categoryId:categoryId,
    		changeset:data
    	});
    }
}

export default new customerService();